var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 16,
    height: 2,
    y: 13,
    rx: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#335498",
    strokeWidth: 1.5,
    d: "M9.36932959,5.44900071 L12.2871776,5.44900071 C12.5633199,5.44900071 12.7871776,5.22514308 12.7871776,4.94900071 C12.7871776,4.81813444 12.7358704,4.69248412 12.6442694,4.59902156 L8.35709187,0.224714686 C8.16380373,0.0274982985 7.84723725,0.0243138303 7.65002087,0.217601977 C7.64762617,0.219948971 7.64525515,0.222319994 7.64290816,0.224714686 L3.35573061,4.59902156 C3.16244246,4.79623795 3.16562693,5.11280442 3.36284332,5.30609257 C3.45630587,5.3976935 3.58195619,5.44900071 3.71282246,5.44900071 L6.63067044,5.44900071 L6.62930112,10.4999125 C6.629233,10.7760549 6.8530354,10.9999678 7.12917777,11.0000359 C7.12921888,11.0000359 7.12925999,11.0000359 7.12930111,11.0000359 L8.86796026,10.9997892 C9.14405447,10.9997892 9.36789214,10.7760067 9.36796025,10.4999125 L9.36932959,5.44900071 Z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 1,
    x: 0.75,
    y: 13.75,
    stroke: "#335498",
    strokeWidth: 1.5,
    rx: 0.5
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Export.be1a8adf.svg";
export { ForwardRef as ReactComponent };